// extracted by mini-css-extract-plugin
export default {"root":"ConfirmModal_root__cf-mf","buttonWrapper":"ConfirmModal_buttonWrapper__Yrqr7"};